import html2canvas from 'html2canvas'
/**
 * 综合检查图片是否可加载和使用
 * @param {string} url - 图片地址
 * @returns {Promise<{success: boolean, width?: number, height?: number, error?: string}>}
 */
export function validateImage(url) {
  return new Promise((resolve) => {
    const img = new Image()

    img.onload = () => {
      // 图片加载成功，返回尺寸信息
      resolve({
        success: true,
        width: img.naturalWidth,
        height: img.naturalHeight
      })
    }

    img.onerror = () => {
      // 图片加载失败
      resolve({
        success: false,
        error: '图片加载失败'
      })
    }

    // 设置跨域属性（如果需要）
    img.crossOrigin = 'anonymous'
    img.src = url
  })
}
// json 模板json,
// certifyQrcodeId 证书的id用于制作二维码,
// e是否制作前销毁dom,1不销毁，2销毁
// certificateUrl 如果没有json使用默认的图片，针对自己上传的证书
// seal_val 印章预览路径， 为1时不显示印章
export async function divToCavasToimg(
  json,
  certifyQrcodeId,
  e,
  certificateUrl,
  seal_val
) {
  const punctuationMarksList = [
    // 常用中文标点符号
    '。',
    '，',
    '、',
    '；',
    '：',
    '？',
    '！',
    '"',
    '"',
    '\'',
    '\'',
    '（',
    '）',
    '【',
    '】',
    '《',
    '》',
    '〈',
    '〉',
    '「',
    '」',
    '『',
    '』',
    '〔',
    '〕',
    '…',
    '—',
    '–',
    '·',
    '～',
    '〃',
    '々',
    '〆',
    '〇',

    // 英文标点符号（通常在中英混排中也会出现）
    '.',
    ',',
    ';',
    ':',
    '?',
    '!',
    '"',
    '"',
    '\'',
    '\'',
    '(',
    ')',
    '[',
    ']',
    '<',
    '>',

    // 其他符号
    '-',
    '*',
    '/',
    '\\',
    '|',
    '&',
    '@',
    '#',
    '$',
    '%',
    '^',
    '+',
    '=',
    '{',
    '}',
    '~',
    '`'
  ]

  /**
   * 去除文本中指定标点符号前的所有空格
   * @param {string} text - 要处理的文本
   * @returns {string} 处理后的文本
   */
  function removeSpacesBeforePunctuation(text, list, j) {
    let result = text

    // 遍历所有标点符号，去除其前面的空格
    for (const punct of punctuationMarksList) {
      // 转义特殊正则字符，避免正则表达式错误
      const escapedPunct = punct.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      // 匹配一个或多个空格后跟标点符号，替换为标点符号本身（去除标点前空格）
      const beforeRegex = new RegExp('\\s+' + escapedPunct, 'g')
      result = result.replace(beforeRegex, punct)

      // 匹配标点符号后跟一个或多个空格，替换为标点符号本身（去除标点后空格）
      const afterRegex = new RegExp(escapedPunct + '\\s+', 'g')
      result = result.replace(afterRegex, punct)
    }
    // 当下一个首字符为符号，去除末尾空格
    for (let i = 0; i < punctuationMarksList.length; i++) {
      if (
        list[j + 1] &&
        list[j + 1].value &&
        getFirstNonSpaceChar1(list[j + 1].value) === punctuationMarksList[i]
      ) {
        result = result.replace(/\s+$/, '')
        // console.log('hahaha', result);
      }
    }

    return result
  }

  function getFirstNonSpaceChar1(str) {
    if (!str) return ''

    const match = str.match(/\S/)
    return match ? match[0] : ''
  }

  const dom2 = document.getElementById('CAVASPREWIEW')
  dom2.innerHTML = ''
  if (certificateUrl) {
    let urlNew = certificateUrl
    if (certificateUrl) {
      // const res2 = await window.yskjConfig.yskt_getFileUrlNoAuth([
      //     certificateUrl,
      // ]);
      urlNew = certificateUrl
    }
    const validateImageRes = await validateImage(urlNew)
    if (validateImageRes.success) {
      return urlNew
    } else {
      console.log('图片加载失败,采用前端渲染')
    }
  }
  // console.log(JSON.parse(json))
  const jsonData = JSON.parse(json)
  const time = new Date().getTime()
  const bg_url = jsonData.url
  // if (jsonData.url.substr(0, 5) !== "/img/") {
  //     if (jsonData.url) {
  //         const res2 = await window.yskjConfig.yskt_getFileUrlNoAuth([
  //             jsonData.url,
  //         ]);
  //         bg_url = res2[0].url;
  //     }
  // } else {
  //     if (process.env.NODE_ENV === "development") {
  //         bg_url = jsonData.url;
  //     } else {
  //         bg_url = `/yskt/certify${jsonData.url}`;
  //     }
  // }
  let dom1 = `<img style="position:absolute;top:0;left:0;width:${jsonData.width}px;height:${jsonData.height}px" src="${bg_url}" crossorigin="anonymous">`
  console.log(jsonData, time, bg_url)
  for (let i = 0; i < jsonData.columns.length; i++) {
    if (
      jsonData.columns[i].filed !== 'qrCode' &&
      jsonData.columns[i].filed !== 'picture' &&
      jsonData.columns[i].filed !== 'combinedVariable' &&
      jsonData.columns[i].filed !== 'seal'
    ) {
      dom1 += `<div
        style="
          white-space: pre-wrap;
          position:absolute;
          color: ${jsonData.columns[i].style.color};
          font-family: ${jsonData.columns[i].style.fontFamily};
          font-size: ${jsonData.columns[i].style.fontSize};
          font-style: ${jsonData.columns[i].style.fontStyle};
          font-weight: ${jsonData.columns[i].style.fontWeight};
          letter-spacing: ${jsonData.columns[i].style.letterSpacing
          ? jsonData.columns[i].style.letterSpacing
          : 1
        }px;
          line-height: ${jsonData.columns[i].style.lineHeight
          ? jsonData.columns[i].style.lineHeight
          : 1
        };
          text-align: ${jsonData.columns[i].style.textAlign
          ? jsonData.columns[i].style.textAlign
          : 'left'
        };
          width: ${jsonData.columns[i].style.width}px;
          height: auto;
          left: ${jsonData.columns[i].style.x}px;
          top: ${jsonData.columns[i].style.y}px;
          z-index: ${jsonData.columns[i].style.zIndex};
          display: ${jsonData.columns[i].phoneLookType === 1 ||
          jsonData.columns[i].idCardLookType === 2
          ? 'none'
          : 'block'
        };
          word-break: normal;
          overflow-wrap: break-word;
        "
      >${jsonData.columns[i].value}${jsonData.columns[i].filed === 'username'
          ? jsonData.columns[i].suffix
          : ''
        }</div>`
    }
    if (
      jsonData.columns[i].filed === 'picture' ||
      (jsonData.columns[i].filed === 'seal' && !seal_val)
    ) {
      let picUrl = ''
      if (jsonData.columns[i].value !== '' && jsonData.columns[i].value) {
        // if (jsonData.columns[i].value.substr(0, 5) != "/img/") {
        //   const res2 = await window.yskjConfig.yskt_getFileUrlNoAuth([
        //     jsonData.columns[i].value,
        //   ]);
        //   picUrl = res2[0].url;
        // } else {
        //   if (process.env.NODE_ENV === "development") {
        //     picUrl = jsonData.columns[i].value;
        //   } else {
        //     picUrl = `/yskt/certify${jsonData.columns[i].value}`;
        //   }
        // }
        picUrl = `${seal_val}`
        dom1 += `<img
    crossorigin='anonymous'
    src='${picUrl}'
    style='
      position:absolute;
      width: ${jsonData.columns[i].style.width}px;
      left: ${jsonData.columns[i].style.x}px;
      top: ${jsonData.columns[i].style.y}px;
      z-index: ${jsonData.columns[i].style.zIndex};
      height: ${jsonData.columns[i].style.height}px;
      opacity: ${jsonData.columns[i].style.opacity};
    '
  >`
      }
    }
    if (jsonData.columns[i].filed === 'seal' && seal_val && seal_val !== 1) {
      let picUrl = ''
      // if (seal_val.substr(0, 5) != "/img/") {
      //   if (seal_val) {
      //     const res2 = await window.yskjConfig.yskt_getFileUrlNoAuth([
      //       seal_val,
      //     ]);
      //     picUrl = res2[0].url;
      //   }
      // } else {
      //   if (process.env.NODE_ENV === "development") {
      //     picUrl = seal_val;
      //   } else {
      //     picUrl = `/yskt/certify${seal_val}`;
      //   }
      // }
      picUrl = `${seal_val}`
      dom1 += `<img
        crossorigin="anonymous"
        src="${picUrl}"
        style="
          position:absolute;
          width: ${jsonData.columns[i].style.width}px;
          left: ${jsonData.columns[i].style.x}px;
          top: ${jsonData.columns[i].style.y}px;
          z-index: ${jsonData.columns[i].style.zIndex};
          height: ${jsonData.columns[i].style.height}px;
          opacity: ${jsonData.columns[i].style.opacity};
        "
      >`
    }
    if (jsonData.columns[i].filed === 'combinedVariable') {
      dom1 += `<div
        style="
          position:absolute;
          width: ${jsonData.columns[i].style.width}px;
          height: auto;
          left: ${jsonData.columns[i].style.x}px;
          top: ${jsonData.columns[i].style.y}px;
          z-index: ${jsonData.columns[i].style.zIndex};
          text-align: left;
          word-break: normal;
          overflow-wrap: break-word;
        "
      >`

      const specialLineBreakIds = ['1768966085495', '1768966236394', '17689662974766']
      for (let j = 0; j < jsonData.columns[i].list.length; j++) {
        if (specialLineBreakIds.includes(jsonData.columns[i].list[j].id)) {
          dom1 += '<br>' + `<span style="
              white-space: pre-wrap;
              font-weight: ${jsonData.columns[i].list[j].style.fontWeight};
              color: ${jsonData.columns[i].list[j].style.color};
              font-family: ${jsonData.columns[i].list[j].style.fontFamily};
              font-size: ${jsonData.columns[i].list[j].style.fontSize};
              font-style: ${jsonData.columns[i].list[j].style.fontStyle};
              letter-spacing: ${jsonData.columns[i].style.letterSpacing
              ? jsonData.columns[i].style.letterSpacing
              : 1
            }px;
              line-height: ${jsonData.columns[i].style.lineHeight
              ? jsonData.columns[i].style.lineHeight
              : 1
            };
              text-align: left;
              padding-left:32px;
            ">${removeSpacesBeforePunctuation(
              jsonData.columns[i].list[j].value,
              jsonData.columns[i].list,
              j
            )}</span>`
        } else {
          dom1 += `<span style="
              white-space: pre-wrap;
              font-weight: ${jsonData.columns[i].list[j].style.fontWeight};
              color: ${jsonData.columns[i].list[j].style.color};
              font-family: ${jsonData.columns[i].list[j].style.fontFamily};
              font-size: ${jsonData.columns[i].list[j].style.fontSize};
              font-style: ${jsonData.columns[i].list[j].style.fontStyle};
              letter-spacing: ${jsonData.columns[i].style.letterSpacing
              ? jsonData.columns[i].style.letterSpacing
              : 1
            }px;
              line-height: ${jsonData.columns[i].style.lineHeight
              ? jsonData.columns[i].style.lineHeight
              : 1
            };
              text-align: left;
            ">${removeSpacesBeforePunctuation(
              jsonData.columns[i].list[j].value,
              jsonData.columns[i].list,
              j
            )}</span>`
        }
      }

      dom1 += '</div>'
    }
  }

  // 预处理所有图片为 base64
  async function convertImagesToBase64(htmlString) {
    // 匹配图片标签中的 src 属性
    const imgRegex = /<img[^>]*src=["']([^"']+)["'][^>]*>/gi
    const matches = [...htmlString.matchAll(imgRegex)]

    // 为了避免在循环中修改字符串，我们从后往前替换
    for (let i = matches.length - 1; i >= 0; i--) {
      const match = matches[i]
      const fullMatch = match[0]
      const imageUrl = match[1]

      // 跳过已经为 base64 的图片
      if (imageUrl.startsWith('data:image')) {
        continue
      }

      try {
        const base64 = await urlToBase64(imageUrl)
        // 替换整个 img 标签中的 src 属性
        const newImgTag = fullMatch.replace(imageUrl, base64)
        htmlString = htmlString.replace(fullMatch, newImgTag)
      } catch (error) {
        console.error(
          'Failed to convert image to base64:',
          imageUrl,
          error
        )
        // 如果转换失败，保留原始 URL
      }
    }

    return htmlString
  }

  /**
   * 将图片 URL 转换为 base64 格式
   * @param {string} url - 图片 URL
   * @returns {Promise<string>} - 返回 base64 格式的图片数据
   */
  function urlToBase64(url) {
    return new Promise((resolve, reject) => {
      // 检查是否已经是 base64 格式
      if (url.startsWith('data:image')) {
        resolve(url)
        return
      }

      const img = new Image()
      img.crossOrigin = 'anonymous' // 设置跨域属性

      img.onload = () => {
        try {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          canvas.width = img.width
          canvas.height = img.height

          // 绘制图片到 canvas
          ctx.drawImage(img, 0, 0)

          // 转换为 base64
          const dataURL = canvas.toDataURL('image/png')
          resolve(dataURL)
        } catch (error) {
          reject(
            new Error(
              'Failed to convert image to base64: ' +
              error.message
            )
          )
        }
      }

      img.onerror = (error) => {
        reject(
          new Error(
            'Failed to load image: ' + url + ' - ' + error.message
          )
        )
      }

      img.src = url
    })
  }
  console.log(dom1)
  dom1 = await convertImagesToBase64(dom1)

  return new Promise((resolve, reject) => {
    const dom = document.createElement('CAVASPREWIEW2')
    dom.style.width = jsonData.width + 'px'
    dom.style.height = jsonData.height + 'px'

    dom.innerHTML = dom1
    dom2.appendChild(dom)
    setTimeout(async () => {
      const width = jsonData.width
      const height = jsonData.height
      const canvas = await html2canvas(dom, {
        width,
        height,
        dpi: window.devicePixelRatio * 96,
        useCORS: true,
        textBaseLine: 'top'
      })
      const img = await canvas.toDataURL('image/jpeg')
      resolve(img)
    }, 0)
  })
}
